import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { parseRequired } from '../../../Utils/form.util';
import { loadDOMComponent } from '../../../helpers';
import { store } from '../../../store/store';
import { AppContextProvider } from '../../../Services/AppContext';
import VideoWithPlayCountAndRadioOptionsInput from './VideoWithPlayCountAndRadioOptionsInput';

loadDOMComponent({
	selector: 'react-video-with-play-count-and-radio-options',
	callback: ({ container, context }: any) => {
		const src = container.getAttribute('data-src');
		const playcountName = container.getAttribute('playcount-name');
		const answerName = container.getAttribute('answer-name');
		const scoreName = container.getAttribute('score-name');
		const playcountNetteRules = container.getAttribute('playcount-nette-rules');
		const answerNetteRules = container.getAttribute('answer-nette-rules');
		const scoreNetteRules = container.getAttribute('score-nette-rules');
		const playDelayInSeconds = parseInt(
			container.getAttribute('playDelayInSeconds'),
		);
		const maxPlays = parseInt(container.getAttribute('maxPlays'));
		const playRequired = parseRequired(container.getAttribute('playRequired'));
		const required = parseRequired(container.getAttribute('required'));
		const options = JSON.parse(container.getAttribute('data-options') ?? '[]');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<VideoWithPlayCountAndRadioOptionsInput
						video={src}
						playcountName={playcountName}
						scoreName={scoreName}
						answerName={answerName}
						playcountNetteRules={playcountNetteRules}
						answerNetteRules={answerNetteRules}
						scoreNetteRules={scoreNetteRules}
						playDelayInSeconds={playDelayInSeconds}
						maxPlays={maxPlays}
						playRequired={playRequired}
						required={required}
						options={options}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
